import type {ReactElement} from "react";
import {Modal} from '@Components/modal';
import {MODALS_IDS} from '@/components/modal-container';
import {LazyPanel} from "@Components/lazy-panel";
import {PANEL_ID} from '@Panels/ai-redesign-prompt-box-panel/ai-redesign-prompt-box-panel.types';
import {useModalData} from "@Components/modal/hooks/useModalData";

export default function AiRedesignPromptBoxModal(): ReactElement {
    const modalData = useModalData(MODALS_IDS.AI_REDESIGN_PROMPT_BOX_MODAL);
    const height = '90vh';
    const width = '100%';

    return (
      <Modal modalId={MODALS_IDS.AI_REDESIGN_PROMPT_BOX_MODAL} panelId={PANEL_ID} mobileHeight={height} modalHeight={height} modalWidth={width} stickToBottom>
        <LazyPanel panelDirectoryName={PANEL_ID} panelProps={modalData.panelProps} />
      </Modal>
    );
}